// utils/blocklist.js
const BLOCKLIST_KEY = 'blockedUserIds';

export const getBlockedUsers = () => {
  const list = localStorage.getItem(BLOCKLIST_KEY);
  return list ? JSON.parse(list) : [];
};

export const addBlockedUser = (userId) => {
  const list = getBlockedUsers();
  if (!list.includes(userId)) {
    list.push(userId);
    localStorage.setItem(BLOCKLIST_KEY, JSON.stringify(list));
  }
};

export const removeBlockedUser = (userId) => {
  const list = getBlockedUsers().filter(id => id !== userId);
  localStorage.setItem(BLOCKLIST_KEY, JSON.stringify(list));
};

export const isUserBlocked = (userId) => {
  const list = getBlockedUsers();
  return list.includes(userId);
};
